import { FC } from 'react';

import { Box } from '@mui/material';

interface WantedPersonFlagProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const WantedPersonFlag: FC<WantedPersonFlagProps> = ({
  className = '',
  size = 'medium',
}) => {
  const sizeStyles = {
    small: { width: 48, height: 24, fontSize: '0.75rem' },
    medium: { width: 64, height: 32, fontSize: '0.875rem' },
    large: { width: 80, height: 40, fontSize: '1rem' },
  };

  return (
    <Box
      className={className}
      sx={{
        ...sizeStyles[size],
        backgroundColor: 'error.main',
        color: 'white',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 2,
      }}
      title="This person has a wanted person record"
      role="alert"
      aria-label="Wanted person record indicator"
    >
      Wanted
    </Box>
  );
};

export default WantedPersonFlag;
